import {EventListener} from "./eventVerteiler";
import {INTERFRAMEMESSAGES} from "./InterframeMessages";
import globalsObject from "../js/globalsObject";
import {LOOPTRACKINGEVENTNAMES} from "./loopTracker";

export enum EXEMPLARYVIEW_PURPOSE {
    "EDIT" = "EDIT",
    "EDIT_PUT_IN_BASKET" = "EDIT_PUT_IN_BASKET",
    "ALREADY_ORDERED_PROMPTNEWSAVE" = "ALREADY_ORDERED_PROMPTNEWSAVE",
    "REVIEW_ORDER" = "REVIEW_ORDER",
    "IN_SHOPPINGCART_PROMPT_GOTOSHOPPINGCART"= "IN_SHOPPINGCART_PROMPT_GOTOSHOPPINGCART"
}

export class ExemplarlisteWrapper extends EventListener{
    protected readonly open: () => void;
    protected readonly close: () => void;
    protected readonly language: string;
    protected readonly setURL: (url:string) => void;

    public constructor(language:string, open:()=>void, close:()=>void, seturl:(url:string)=>void) {
        super();
        this.language = language;
        this.open = open;
        this.close = close;
        this.setURL = seturl;
    }

    public openExemplarlisteByPurpose(saveid:string|number, lieferland:string, purpose:EXEMPLARYVIEW_PURPOSE):Promise<void> {
        this.setURL(this.createUrlByPurpose(saveid, lieferland, purpose));
        return new Promise<void>((resolve)=>{
            this.open();
            this.addEventListener(INTERFRAMEMESSAGES.EXEMPLARLISTE_CANCEL, () => {
                this.close();
                this.removeAllEventListeners();
            })
            this.addEventListener(INTERFRAMEMESSAGES.EXEMPLARLISTE_SAVED, ()=>{
                resolve();
                this.close();
                this.removeAllEventListeners();
            })
            this.addEventListener(INTERFRAMEMESSAGES.ADD_ITEM_TO_CART, (data:any)=>{
                globalsObject.loopTracker.trackSingleCartItemEvent(LOOPTRACKINGEVENTNAMES.KONFI_ADD_TO_CART, data.currency, data.value, data.item);
            })
        })
    }
    protected createURL(saveid:string|number, lieferland:string, continueButtonText:string, readOnly:string) {
        return [window.location.origin, "exemplarliste", this.language, lieferland || this.language, saveid, continueButtonText, readOnly].join("/");
    }

    protected createUrlByPurpose(saveid:string|number, lieferland:string, purpose:EXEMPLARYVIEW_PURPOSE) {
        switch(purpose){
            case EXEMPLARYVIEW_PURPOSE.EDIT_PUT_IN_BASKET:
                return this.createURL(saveid, lieferland, "konf_toBasket", "")
            case EXEMPLARYVIEW_PURPOSE.EDIT:
                return this.createURL(saveid, lieferland, "konf_Save", "");
            case EXEMPLARYVIEW_PURPOSE.ALREADY_ORDERED_PROMPTNEWSAVE:
                return [window.location.origin, "exemplarliste/alreadyordered", this.language, lieferland || this.language, saveid].join("/");
            case EXEMPLARYVIEW_PURPOSE.REVIEW_ORDER:
                return [window.location.origin, "exemplarliste/revieworder", this.language, lieferland || this.language, saveid].join("/");
            case EXEMPLARYVIEW_PURPOSE.IN_SHOPPINGCART_PROMPT_GOTOSHOPPINGCART:
                return [window.location.origin, "exemplarliste/currentlyinshoppingcart", this.language, lieferland || this.language, saveid].join("/");
        }
    }
}





